import React, { useState } from "react";
import { Link } from "react-router-dom";

import siteLogo from "../vendor/images/icons/siteLogo.png";
import mapMetk from "../vendor/images/icons/mapMetk.svg";
import teleph from "../vendor/images/icons/teleph.svg";
import email from "../vendor/images/icons/email.svg";

import { CopyrightModalGKH } from "./CopyrightModal/CopyrightModalGKH.jsx";
import "./Footer.css";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <footer className="footer">
      <div className="footer__privacy-link-container">
        <div className="footer__container footer__container__leftblock">
          <div className="footer__container__leftblock__logo">
            <a href="#top">
              <img
                src={siteLogo}
                alt="Логотип ЖКХ-Инфо"
                className="footer_logo_left"
              />
            </a>
            <p className="footer__copyright footer_text_name_left">
              IT компания ЖКХ-Инфо
            </p>
          </div>
          <div className="footer__container__leftblock__text">
            © Общество с ограниченной ответственностью "ЖКХ Инфо Красноярск"
          </div>
          <div className="footer__container__leftblock__text">
            Все права защищены {new Date().getFullYear()}
          </div>
          <div
            className="footer__container__leftblock__text"
            onClick={handleOpenModal}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Подробнее
          </div>
          <div className="footer__container__leftblock__text">
            {" "}
            <Link
              className="footer__privacy-link"
              to="/privacy"
              target="_blank"
            >
              Политика обработки персональных данных
            </Link>
          </div>
        </div>
        <div className="footer__container footer__container__rightblock">
          <div className="footer__container__rightblock__line">
            <div className="footer__container__rightblock__line__img">
              <img
                src={mapMetk}
                alt="Иконка метки на карте"
                className="footer_logo_right_tel_map_email"
              />
            </div>
            <div className="footer__container footer__container__adress">
              <p className="footer__adress_new">
                Россия, 660135, Красноярский край,
              </p>
              <p className="footer__adress_new">
                г. Красноярск, ул. Взлетная, д.7А, пом.164
              </p>
            </div>
          </div>
          <div className="footer__container__rightblock__line">
            <div className="footer__container__rightblock__line__img">
              <img
                src={teleph}
                alt="Иконка телефона"
                className="footer_logo_right_tel_map_email"
              />
            </div>
            <div className="footer__container">
              <a className="footer__tel_email" href="tel:+79029268824">
                + 7 (902) 926-88-24
              </a>
            </div>
          </div>
          <div className="footer__container__rightblock__line">
            <div className="footer__container__rightblock__line__img">
              <img
                src={email}
                alt="Иконка почты"
                className="footer_logo_right_tel_map_email"
              />{" "}
            </div>
            <div className="footer__container">
              <a
                className="footer__tel_email"
                href="mailto:mpsupport@kras-abs.ru"
              >
                mpsupport@kras-abs.ru
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Модальное окно для ЖКХ-Инфо */}
      <CopyrightModalGKH isOpen={isModalOpen} onClose={handleCloseModal} />
    </footer>
  );
};

export default Footer;
